<div class="d-flex flex-column align-items-center justify-content-center">

  <div class="form w-50" *ngIf="missingToken && !resetSuccess">
    <h4 class="mb-3">Invalid Reset Link</h4>
    <p style="color: red">This password reset link is invalid. Please request a new one.</p>
    <div class="row m-3">
      <a routerLink="/identity/forgot-password">Request New Reset Link</a>
    </div>
    <div class="row m-3">
      <a routerLink="/identity/signin">Back to Sign In</a>
    </div>
  </div>

  <div class="form w-50" *ngIf="!missingToken && !resetSuccess">
    <h4 class="mb-3">Reset Password</h4>

    <form [formGroup]="resetForm" (submit)="onSubmit()">
      <div class="row m-3">
        <label>Email</label>
        <input class="col form-field" [value]="email" disabled />
      </div>

      <div class="row m-3">
        <label for="newPassword">New Password*</label>
        <input class="col form-field" type="password" name="newPassword" formControlName="newPassword" autocomplete="new-password" />
      </div>

      <div class="row m-3" *ngIf="resetForm.controls['newPassword'].touched && resetForm.controls['newPassword'].errors">
        <label style="color: red" *ngIf="resetForm.controls['newPassword'].errors?.['required']">Password is required</label>
        <label style="color: red" *ngIf="resetForm.controls['newPassword'].errors?.['minlength']">Password must be at least 6 characters</label>
      </div>

      <div class="row m-3">
        <label for="confirmPassword">Confirm Password*</label>
        <input class="col form-field" type="password" name="confirmPassword" formControlName="confirmPassword" autocomplete="new-password" />
      </div>

      <div class="row m-3" *ngIf="passwordMismatch">
        <label style="color: red">Passwords do not match</label>
      </div>

      <div class="row m-3" *ngIf="errorMessages.length > 0">
        <label style="color: red" *ngFor="let msg of errorMessages">{{ msg }}</label>
      </div>

      <div class="mb-3 mx-3">
        <small class="text-muted">
          Password must be at least 6 characters and contain an uppercase letter, lowercase letter, digit, and special character.
        </small>
      </div>

      <div class="row m-3">
        <button class="col btn btn-primary" [disabled]="!resetForm.valid || passwordMismatch || submitting" type="submit">
          {{ submitting ? 'Resetting...' : 'Reset Password' }}
        </button>
      </div>
    </form>
  </div>

  <div class="form w-50" *ngIf="resetSuccess">
    <h4 class="mb-3">Password Reset Successful</h4>
    <p>Your password has been reset. You can now sign in with your new password.</p>
    <div class="row m-3">
      <a routerLink="/identity/signin" class="btn btn-primary">Sign In</a>
    </div>
  </div>

</div>
